{
  "meta": {
    "home": {
      "title": "BYHOURS: Prenota in più di 4.000 hotel a ore",
      "description": "Ora potete prenotare una camera all'ora nel vostro hotel preferito e decidere l'orario di check-in. Scegliete tra oltre 4.000 hotel a 3, 4 e 5 stelle e prenotate in oltre 25 Paesi. Accesso a tutti i servizi dell'hotel con cancellazione gratuita. Prenotate ora con BYHOURS, leader nei microsoggiorni.",
      "keywords": "hotel ad ore, camere ad ore, ore di hotel, alberghi ad ore, prenotare hotel a ore, albergo a ore, alberghi a ore, daybreakhotels, dayuse, hotel per ore, hotel per ore Milano, hotel per ore Roma, hotel per ore Torino, hotel per ore Venezia, hotel per ore Firenze, hotel per ore Napoli, hotel a ore, camera ore, hotel diurni, hotel diurno, hotel giorno, Camere per ore, camera per un giorno, stanze in affitto a ore, camere da prenotare a ore, esperienze per ore, camere a ore per coppie, hotel a ore per coppie, hotel economico a ore, hotel a ore con spa, Hotel economico a ore, hotel aeroporto ore, Hotel Day, camera giorno, Hotel aeroporto a ore, albergo a scalo, hotel a ore per lavorare, hotel a ore aeroporto, hotel di passaggio, alloggio a ore, hotel per coppie, byhours"
    },
    "search": {
      "title": "Hotel a ore in {city_name}",
      "description": "I migliori hotel di {city_name} disponibili a ore in pacchetti di 3, 6 e 24 ore. Per uso diurno e notturno con accesso a tutte le strutture alberghiere. Cancellazione gratuita e check-in flessibile.",
      "keywords": "hotel ad ore a {city_name}, camere ad ore {city_name}, ore di hotel {city_name}, alberghi ad ore {city_name}, prenotare hotel a ore, hotel {city_name}, hotel per ore {city_name}, microsoggiorni {city_name}, hotel aeroporto {city_name}, hotel per coppie {city_name}, {city_name}, byhours {city_name}, byhours"
    },
    "detail": {
      "title": "{hotel_name} {city_name} per 3, 6 o 24 ore",
      "description": "Concedetevi qualche ora di relax in {hotel_name} a {city_name} e pagate solo per il tempo di cui avete bisogno. Scegliete l'orario di check-in che più vi aggrada e godetevi tutti i servizi come la spa, la piscina o il ristorante. {hotel_description}",
      "keywords": "hotel ad ore a {city_name}, camere ad ore {hotel_name}, ore di hotel {hotel_name}, alberghi ad ore {city_name}, prenotare hotel a ore, hotel {city_name}, microsoggiorni {hotel_name}, hotel aeroporto {hotel_name}, hotel per coppie {hotel_name}, {hotel_name}, byhours {hotel_name}, byhours"
    },
    "landing": {
      "title": "Hotel a ore in {city_name}",
      "description": "I migliori hotel di {city_name} disponibili a ore in pacchetti di 3, 6 e 24 ore. Per uso diurno e notturno con accesso a tutte le strutture alberghiere. Cancellazione gratuita e check-in flessibile.",
      "keywords": "hotel ad ore a {city_name}, camere ad ore {city_name}, ore di hotel {city_name}, alberghi ad ore {city_name}, prenotare hotel a ore, hotel {city_name}, hotel per ore {city_name}, microsoggiorni {city_name}, hotel aeroporto {city_name}, hotel per coppie {city_name}, {city_name}, byhours {city_name}, byhours"
    },
    "como-funciona": {
      "title": "Come prenotare hotel a ore: passo dopo passo",
      "description": "Scopri come in soli 4 semplici passaggi puoi goderti 3, 6 o 24 ore in un hotel in oltre 600 destinazioni.",
      "keywords": "dubbi, passaggi, come prenotare, byhours, hotel a ore"
    },
    "byhours-destinations": {
      "title": "Prenota in più di 600 destinazioni",
      "description": "Prenotate le camere all'ora nel vostro hotel preferito e decidete l'orario del check-in. Scegliete tra oltre 4.000 hotel a 3, 4 e 5 stelle e prenotate in oltre 600 destinazioni. Accesso a tutti i servizi dell'hotel con cancellazione gratuita. Prenotate ora con BYHOURS, leader nei microalloggi.",
      "keywords": "destinazioni, byhours, hotel"
    },
    "privacy": {
      "title": "Informativa sulla privacy",
      "description": "Informativa sulla privacy e sulla protezione dei dati di BYHOURS. Informazioni sul trattamento dei tuoi dati personali quando utilizzi i nostri servizi di prenotazione di hotel a ore."
    },
    "terms": {
      "title": "Termini e condizioni",
      "description": "Termini e condizioni d'uso del servizio BYHOURS. Condizioni per prenotare camere d'hotel a ore in oltre 4.000 hotel."
    },
    "onDemand": {
      "title": "BYHOURS On Demand — Richiesta di disponibilità",
      "description": "Dicci di cosa hai bisogno e il nostro team ti aiuterà a trovare disponibilità su richiesta."
    },
    "hoteliers": {
      "title": "BYHOURS per hotel — Trasforma le ore vuote in ricavi",
      "description": "Vendi microsoggiorni in fasce da 3, 6 e 24 ore con le tue regole: prezzo, disponibilità e canale proprio. Nessun minimo garantito.",
      "ogTitle": "BYHOURS per hotel",
      "ogDescription": "Monetizza l’inventario inutilizzato con microsoggiorni e controllo totale dall’extranet."
    }
  },
  "stickyBookingBar": {
    "reservarAhora": "Prenota ora",
    "elegirHora": "Scegli orario",
    "aria": "Barra di prenotazione rapida"
  },
  "roomCard": {
    "badges": {
      "freeCancellation": "Cancellazione gratuita fino a 24h",
      "payNow": "Paga ora",
      "payAtDestination": "Paga in struttura"
    },
    "packWindow": {
      "allDay": "Tutto il giorno"
    },
    "packOption": {
      "hours": "{count} ore",
      "vatIncluded": "IVA inclusa",
      "availabilityTitle": "Disponibilità",
      "extraHourPromo": "Include 1h extra di soggiorno"
    },
    "realPrice": {
      "taxesIncluded": "Tasse e commissioni incluse",
      "taxesNotIncluded": "Tasse e commissioni non incluse",
      "taxesBreakdown": "Dettaglio tasse e commissioni"
    },
    "reserve": "Prenota"
  },
  "searchCard": {
    "urgency": {
      "oneRoom": "Resta 1 camera",
      "moreRooms": "Restano {count} camere"
    },
    "viewRooms": "Vedi camere",
    "availablePacks": {
      "one": "Soggiorno di {pack}h",
      "many": "Soggiorni {packs}"
    },
    "promos": {
      "multiple": "{count} promozioni",
      "modalTitle": "Promozioni disponibili"
    }
  },
  "buttons": {
    "borrar": "Cancella",
    "reiniciar": "Reimposta",
    "aplicar": "Applica",
    "cerrar": "Chiudi",
    "filtros": "Filtri",
    "buscar": "Cerca",
    "cargando": "Caricamento",
    "mapa": "Mappa mondiale",
    "buscarZona": "Cerca in questa zona",
    "filtroEntrada": "Orario di check-in",
    "eligeHorario": "Scegli il tuo orario",
    "continuar": "Continua",
    "continuarSinExtras": "Continua senza extra",
    "cancel": "Annulla",
    "buscarDia": "Cerca un altro giorno",
    "buscarOtroHotel": "Cerca un altro hotel",
    "noDispo": "Nessuna disponibilità",
    "dispo": "Orario di ingresso",
    "dispoOtrosDias": "Disponibile altri giorni",
    "moreImg": "Più immagini",
    "readMore": "Leggi di più",
    "readLess": "Leggi di meno",
    "reservar": "Prenotare",
    "cancelBook": "Annulla prenotazione",
    "modifyBook": "Modifica prenotazione",
    "repeatBook": "Ripeti prenotazione",
    "deleteBook": "Elimina prenotazione",
    "clearHistory": "Cancella cronologia",
    "desde": "Da",
    "todos": "Tutti",
    "login": "Accedi",
    "verMapa": "Vedi mappa",
    "compartir": "Condividi",
    "guardar": "Salva",
    "guardado": "Salvato"
  },
  "labels": {
    "hoy": "Oggi",
    "mañana": "Domani",
    "dia": "giorno",
    "dateRangeShortMinus1": "- 1 giorno",
    "dateRangeShortPlus1": "+ 1 giorno",
    "dateRangeShortBoth": "± 1 giorno",
    "dateRangeMinus1": "Cerca un giorno prima",
    "dateRangePlus1": "Cerca un giorno dopo",
    "dateRangeBoth": "Cerca un giorno prima e dopo",
    "dateRangeSelector": "Amplia la ricerca ai giorni vicini",
    "horas": "ore",
    "hoteles": "hotel",
    "todoDia": "Tutto il giorno",
    "searchDestino": "Destinazioni corrispondenti a",
    "destinosPopulares": "Destinazioni popolari",
    "busquedasRecientes": "Ricerche recenti",
    "placeholderDestino": "Cerca una destinazione...",
    "ubicacion": "Posizione",
    "rooms": "Camere",
    "pack": "Pacchetto ore",
    "entrada": "Check-in",
    "horarioReserva": "Orario di prenotazione",
    "salida": "Uscita",
    "nombre": "Nome",
    "apellido": "Cognome",
    "ciudad": "Città",
    "telefono": "Telefono",
    "extras": "Extras prenotati",
    "password": "Password attuale",
    "newPassword": "Nuova password",
    "repeatPassword": "Ripeti nuova password",
    "passwordRequirements": {
      "length": "Almeno 8 caratteri",
      "uppercase": "Almeno 1 lettera maiuscola",
      "lowercase": "Almeno 1 lettera minuscola",
      "number": "Almeno 1 numero"
    },
    "email": "Email",
    "detalle": "Dettagli",
    "pago": "Dati di pagamento",
    "pagado": "Pagato",
    "total": "Totale",
    "changePassword": "Cambia password",
    "precioHab": "per camera",
    "errorHora": "Scegli il tuo orario di check-in",
    "errorHotel": "Non abbiamo trovato l'hotel",
    "errorDestino": "Destinazione non trovata",
    "errorPaginaNoEncontrada": "Pagina non trovata",
    "errorPaginaNoEncontradaSubtitle": "La pagina che stai cercando non esiste.",
    "verHoteles": "Vedere hotel a {city_name}",
    "verHotelesDisponibles": "Vedere i {count} hotel disponibili a {city_name}",
    "destacados": "Hotel in evidenza a {city_name}",
    "reserva": "Prenota il tuo hotel a ore",
    "descubre": "Scopri hotel a {city_name}",
    "hero": {
      "entradaFlexible": "Check-in flessibile",
      "hotelesVerificados": "Hotel verificati",
      "sinNocheMinima": "Nessun soggiorno minimo"
    },
    "comoFunciona": "Come funziona?",
    "errorResultado": "Upps... Non abbiamo trovato nulla che corrisponda alla sua ricerca.",
    "errorResultadoTitle": "Nessun risultato",
    "destinos": "Destinazioni",
    "selectDestino": "Seleziona un paese",
    "ubicacionActual": "Posizione attuale",
    "zonaActual": "Area selezionata",
    "selectCity": "Seleziona una città",
    "sinDisponibilidadTitle": "Nessuna disponibilità al momento",
    "sinDisponibilidadDescription": "Al momento non ci sono hotel disponibili in questa destinazione. Ti invitiamo a tornare più tardi o esplorare altre opzioni.",
    "buscarOtroDestino": "Cerca un'altra destinazione",
    "buscarOtraUbicacion": "Cerca un'altra posizione",
    "numRooms": "Nº camere",
    "ariaLabelHorarioFlexible": "Informazioni orario flessibile",
    "aria": {
      "home": "Home",
      "idiomaMoneda": "Lingua e valuta",
      "usuario": "Utente",
      "menu": "Menu",
      "favorito": "Preferito",
      "compartir": "Condividi",
      "info": "Informazioni",
      "diaAnterior": "Giorno precedente",
      "diaSiguiente": "Giorno successivo",
      "descargarAppIos": "Scarica app per iOS",
      "descargarAppAndroid": "Scarica app per Android",
      "showPassword": "Mostra password",
      "hidePassword": "Nascondi password"
    },
    "login": {
      "title": "Benvenuto su BYHOURS",
      "password": "Hai dimenticato la password?",
      "session": "Accedi",
      "noAccount": "Non hai un account?",
      "registerLabel": "Registrati",
      "placeholder": {
        "email": "Indirizzo email *",
        "password": "Password *"
      },
      "continue": "Continua",
      "o": "OPPURE",
      "recover": {
        "title": "Recupera la tua password",
        "subtitle": "Inserisci il tuo indirizzo email e ti invieremo le istruzioni per reimpostare la password.",
        "subtitle2": "Inserisci la tua nuova password e conferma la nuova password.",
        "back": "Torna al login"
      },
      "register": {
        "title": "Crea il tuo account su BYHOURS",
        "account": "Hai già un account?"
      },
      "google": "Continua con Google",
      "facebook": "Continua con Facebook",
      "footer": {
        "user": "Accordo con l'utente",
        "privacy": "Informativa sulla privacy",
        "cookies": "Politica sui cookie"
      },
      "emailConfirmation": {
        "title": "Conferma il tuo indirizzo email!",
        "subtitle": "Abbiamo inviato un'email a {email} con un link per confermare il tuo indirizzo email. Se non lo trovi nella tua casella di posta, controlla la cartella spam.",
        "resend": "Reinvia email"
      },
      "dropdown": {
        "perfil": "Profilo",
        "cerrar": "Esci"
      }
    },
    "proximaReserva": {
      "titulo": "Prossima prenotazione",
      "ver": "Vedi prenotazione",
      "repetir": "Ripeti prenotazione",
      "repetirSubtitulo": "{days} giorni fa",
      "repetirSubtituloHoy": "Prenotato oggi",
      "repetirSubtituloAyer": "Prenotato ieri",
      "repetirDescripcion": "Prenotato {days} giorni fa a {hotel}",
      "repetirDescripcionHoy": "Prenotato oggi a {hotel}",
      "repetirDescripcionAyer": "Prenotato ieri a {hotel}"
    },
    "user_zone": {
      "emailVerified": {
        "title": "Email verificata",
        "description": "Ora puoi usare l'area utente come al solito."
      },
      "menu": {
        "perfil": "Profilo",
        "reservas": "Le mie prenotazioni",
        "favoritos": "Preferiti",
        "inicio": "Home BYHOURS",
        "cerrarSesion": "Esci"
      },
      "favoritos": {
        "noFavoritosTitle": "Non hai ancora preferiti",
        "noFavoritosSubtitle": "Cosa aspetti? Segna i tuoi hotel preferiti",
        "completeProfile": "Devi completare il tuo profilo per poter aggiungere hotel ai preferiti"
      },
      "perfil": {
        "danger": "Zona pericolosa",
        "deleteAccount": "Elimina account",
        "deleteAccountText": "Sei sicuro di voler eliminare il tuo account?",
        "deleteAccountText2": "Questa azione è permanente e non può essere annullata. Tutti i tuoi dati saranno eliminati definitivamente.",
        "successUpdate": "Informazioni aggiornate con successo",
        "successDelete": "Utente eliminato con successo"
      },
      "reservas": {
        "noReservasTitle": "Non hai ancora prenotazioni",
        "noReservasSubtitle": "Cosa stai aspettando? Prenota la tua camera con noi",
        "activas": "Attive",
        "pasadas": "Passate",
        "cancelled": "Cancellata",
        "cancel": "Prenotazione annullata correttamente",
        "cancelError": "Errore durante l'annullamento della prenotazione",
        "reference": "Localizzatore",
        "price": "Prezzo",
        "cancelText": "Sei sicuro di voler annullare la prenotazione?",
        "cancelText2": "Se annulli ora, potresti perdere la tua prenotazione attuale.",
        "deleteText": "Sei sicuro di voler eliminare questa prenotazione?",
        "deleteText2": "Questa azione è permanente e non potrai recuperare la prenotazione.",
        "deleteSuccess": "Prenotazione eliminata correttamente",
        "deleteError": "Errore durante l'eliminazione della prenotazione",
        "clearHistoryText": "Sei sicuro di voler cancellare tutta la cronologia?",
        "clearHistoryText2": "Tutte le tue prenotazioni passate saranno nascoste permanentemente.",
        "clearHistorySuccess": "Cronologia cancellata correttamente",
        "clearHistoryError": "Errore durante la cancellazione della cronologia",
        "detalle": {
          "titulo": "Dettagli della prenotazione",
          "tiempo": "Durata del soggiorno"
        }
      }
    },
    "cancelBook": {
      "title": "Annulla prenotazione",
      "subtitle": "Inserisci il codice di prenotazione e l'email utilizzata. Potrai annullare solo se rispetti la politica di cancellazione (ad esempio almeno 24 ore prima del check-in).",
      "referenceError": "Inserisci il codice di prenotazione",
      "referencePlaceholder": "Codice prenotazione",
      "emailPlaceholder": "Email",
      "submit": "Annulla prenotazione",
      "success": "La prenotazione è stata annullata correttamente",
      "genericError": "Impossibile annullare la prenotazione",
      "backHome": "Torna alla home"
    },
    "tags": {
      "piscina": "Goditi l'accesso alla piscina incluso nella tua prenotazione! 💦"
    },
    "tooltips": {
      "packHours": "Puoi prenotare {hours}h in questa fascia oraria",
      "horarioFlexible": "Il tuo check-in è flessibile nell'orario mostrato, ma il check-out deve essere puntuale."
    },
    "extraHours": {
      "maxExtraHours": "Si possono aggiungere al massimo {hours} ore extra",
      "noExtraHours": "Non è possibile aggiungere ore extra all'orario selezionato"
    },
    "horasDisponibles": "Ore disponibili",
    "gratis": "Gratuito"
  },
  "errors": {
    "search": "Si è verificato un errore durante la ricerca degli hotel. Per favore riprova.",
    "ubicacion": {
      "support": "Sembra che il tuo browser non supporti la funzione di geolocalizzazione. Prova un altro browser o abilita l'opzione nelle impostazioni.",
      "block": "La posizione è bloccata nel tuo browser. Per abilitarla, vai alle impostazioni e consenti l'accesso alla posizione.",
      "permission": "Non siamo riusciti ad accedere alla tua posizione perché hai negato il permesso. Puoi abilitarlo nelle impostazioni del tuo dispositivo.",
      "gps": "Non siamo riusciti a determinare la tua posizione. Assicurati di avere il GPS abilitato e una connessione stabile.",
      "timeout": "La richiesta di posizione sta impiegando più tempo del previsto. Per favore riprova tra qualche momento.",
      "error": "Si è verificato un errore durante il tentativo di ottenere la tua posizione. Per favore riprova."
    },
    "login": {
      "email": "Email non valida",
      "password": "Almeno 8 caratteri",
      "passwordComplexity": "Deve contenere almeno una lettera maiuscola, una lettera minuscola e un numero",
      "repeatPassword": "Le password non coincidono",
      "emailDomain": "Il dominio dell'email non sembra valido",
      "facebook_email_required": "Facebook non ha condiviso la tua email con noi. Per fare login con Facebook su BYHOURS, vai alle tue impostazioni delle app Facebook e concedi il permesso email a BYHOURS.",
      "email_verified": "Email confermata. Accedi per continuare.",
      "email_verification_failed": "Non siamo riusciti a confermare la tua email con questo link. Se è già confermata, accedi. Altrimenti vai nell'area utente e invia di nuovo l'email."
    },
    "user_zone": {
      "delete": "Errore durante l'eliminazione dell'utente",
      "password": "Errore durante il cambio della password",
      "email_verification_failed": "Non siamo riusciti a confermare la tua email con questo link. Se era già confermata, l'area si sbloccherà al refresh. Altrimenti invia di nuovo l'email di conferma."
    }
  },
  "share": {
    "copy": "Copia link",
    "whatsapp": "Condividi su WhatsApp",
    "email": "Condividi via email",
    "message": "Ciao! Ti condivido questo hotel che mi è sembrato interessante: {url}"
  },
  "checkout": {
    "meta": {
      "title": "Checkout",
      "description": "Completa la tua prenotazione"
    },
    "timer": "La tua camera è riservata per {time} minuti",
    "steps": {
      "checkinHour": "Ora di check-in",
      "data": "I tuoi dati",
      "payment": "Pagamento sicuro",
      "back": "Indietro"
    },
    "sections": {
      "completeCheckinHour": "Seleziona l'orario di check-in per continuare"
    },
    "checkinHour": {
      "title": "Ora di check-in",
      "subtitle": "Scegli a che ora vuoi entrare",
      "required": "Seleziona un'ora di check-in per continuare",
      "pendingSummary": "Seleziona la tua ora di check-in",
      "description": "Scegli la tua ora di ingresso entro {window}; da quell'ora godrai di {hours} ore di soggiorno.",
      "descriptionNoWindow": "Scegli la tua ora di ingresso; da quell'ora godrai di {hours} ore di soggiorno.",
      "placeholder": "Scegli la tua ora di ingresso",
      "changeHour": "Modifica ora di ingresso",
      "descriptionSelected": "Ingresso flessibile dalle {checkin}. La camera è disponibile dalle {checkin} alle {checkout}."
    },
    "extras": {
      "title": "Extra",
      "continueWithout": "Continua senza extra",
      "noneForHour": "Nessun extra disponibile per l'orario di check-in selezionato"
    },
    "recovery": {
      "title": "Hai una prenotazione in corso",
      "finishBooking": "Completa la mia prenotazione",
      "closeAria": "Chiudi promemoria"
    },
    "contactData": {
      "title": "Dati di contatto",
      "loginPrompt": "Hai già un account?",
      "loginButton": "Accedi",
      "registerButton": "Registrati",
      "loginPromptSuffix": "per velocizzare le tue prenotazioni future.",
      "continueAsGuest": "Continua come ospite",
      "firstName": "Nome",
      "firstNamePlaceholder": "Marco",
      "lastName": "Cognome",
      "lastNamePlaceholder": "Rossi",
      "email": "Email",
      "emailPlaceholder": "marco.rossi{'@'}byhours.com",
      "phone": "Telefono",
      "phonePlaceholder": "3331234567",
      "city": "Città",
      "cityPlaceholder": "Roma"
    },
    "promoCode": {
      "title": "Codice promozionale",
      "placeholder": "Esempio: ESTATE10",
      "apply": "Applica",
      "applied": "Codice promozionale applicato",
      "remove": "Rimuovi",
      "errors": {
        "required": "Inserisci un codice promozionale valido",
        "invalid": "Codice promozionale non valido",
        "generic": "Errore nell'applicazione del codice promozionale"
      }
    },
    "comments": {
      "title": "Commenti per l'hotel",
      "placeholder": "Esempio: 'Ho bisogno di una camera ad accesso per sedia a rotelle'"
    },
    "payment": {
      "title": "Metodo di pagamento"
    },
    "trustBadges": {
      "securePayment": "Pagamento sicuro (Stripe)",
      "freeCancellation": "Cancellazione gratuita",
      "encryptedData": "Dati crittografati"
    },
    "terms": {
      "text": "Prenotando accetti il nostro",
      "userAgreement": "Accordo utente",
      "privacyText": "In BYHOURS tratteremo i tuoi dati personali per gestire la tua prenotazione e tenerti informato durante tutto il processo.",
      "privacyInfo": "Per maggiori informazioni consulta la nostra",
      "privacyPolicy": "Politica sulla privacy"
    },
    "buttons": {
      "continue": "Continua",
      "confirmAndPay": "Conferma e paga ora",
      "payNow": "Paga ora"
    },
    "loading": "Elaborazione del pagamento...",
    "summary": {
      "hotel": "Hotel",
      "address": "Indirizzo",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "hotelTaxes": "Tasse e commissioni dell'hotel",
      "hotelTaxesTooltip": "A seconda della destinazione, alcune tasse e/o commissioni (come la tassa di soggiorno) potrebbero non essere incluse nel prezzo e devono essere pagate direttamente all'hotel",
      "bookingFees": "Commissioni di prenotazione",
      "bookingFeesTooltip": "Commissione come spese di gestione",
      "promoDiscount": "Sconto promozionale",
      "payAtHotel": "Da pagare in hotel",
      "payAtHotelTooltip": "Il pagamento verrà effettuato nella valuta della struttura (il tasso di cambio può variare)",
      "payNow": "Ora paghi solo",
      "total": "TOTALE",
      "taxesIncluded": "Tasse e commissioni incluse",
      "additionalTaxesSuffix": "tasse e commissioni aggiuntive",
      "additionalTaxesBody": "Tasse e imposte non sono incluse e si pagano direttamente in hotel",
      "freeCancellation": "Cancellazione gratuita fino a 24h prima del check-in; in seguito, l'hotel può addebitare l'importo intero.",
      "paymentSplit": "Ora paghi solo {nowAmount}, il resto ({hotelAmount}) da pagare in hotel.",
      "seeDetails": "Vedi dettagli",
      "taxesInfo": "Alcune tasse e/o commissioni (come la tassa di soggiorno) potrebbero non essere incluse nel prezzo finale e devono essere pagate direttamente in hotel"
    },
    "paymentDetails": {
      "title": "Dettagli di pagamento e cancellazione",
      "paymentCharges": {
        "title": "Pagamento e addebiti",
        "item1": "L'addebito che vedrai sul tuo conto sarà: \"Travel Payment\".",
        "item2": "Stai pagando solo una parte ora (spese di gestione) e il resto dell'importo si paga direttamente in hotel.",
        "item3": "Stai pagando l'importo totale dell'alloggio in anticipo."
      },
      "cancellations": {
        "title": "Cancellazioni e mancate presentazioni",
        "item1": "Puoi cancellare la tua prenotazione fino a 24h prima del check-in.",
        "item2": "Se cancelli in tempo, ti rimborseremo l'importo pagato.",
        "item3": "L'hotel si riserva il diritto di addebitare il 100% dell'importo se non ti presenti o cancelli fuori termine."
      },
      "checkIn": {
        "title": "Check-in",
        "idRequired": "Presentare un documento di identità valido (carta d'identità o passaporto) è obbligatorio per tutte le persone che soggiornano."
      },
      "support": {
        "title": "Servizio clienti",
        "scheduleMondayThursday": "Lunedì a Giovedì dalle 9:00 alle 24:00 (UTC/GMT +1)",
        "scheduleFriday": "Venerdì dalle 9:00 alle 21:00 (UTC/GMT +1)",
        "scheduleWeekend": "Sabato, Domenica e festivi dalle 9:30 alle 18:30 (UTC/GMT +1)",
        "whatsapp": "Puoi contattarci tramite",
        "email": "Puoi scriverci a:",
        "phones": "Telefoni di contatto",
        "uk": "Regno Unito:",
        "france": "Francia:",
        "mexico": "Messico:",
        "colombia": "Colombia:",
        "spain": "Spagna:"
      }
    },
    "errors": {
      "title": "Errore",
      "firstNameRequired": "Il nome è obbligatorio",
      "lastNameRequired": "Il cognome è obbligatorio",
      "emailRequired": "L'email è obbligatoria",
      "emailInvalid": "Email non valida",
      "phoneInvalid": "Il numero di telefono può contenere solo cifre",
      "stripeNotAvailable": "Stripe non è disponibile",
      "initializePaymentError": "Errore nell'inizializzazione del pagamento",
      "initializePaymentRetry": "Impossibile inizializzare il pagamento. Riprova.",
      "clientSecretError": "Impossibile ottenere il client secret",
      "paymentContainerError": "Il contenitore di pagamento non è disponibile dopo diversi tentativi",
      "bookingInitError": "Impossibile inizializzare la prenotazione",
      "paymentElementsError": "Elementi di pagamento non inizializzati",
      "confirmPaymentError": "Errore nella conferma del pagamento",
      "paymentIntentError": "Impossibile ottenere il payment intent",
      "paymentIncompleteError": "Il pagamento non è stato completato correttamente. Stato: {status}",
      "authenticationFailure": "La verifica della banca non è andata a buon fine. Inserisci di nuovo la carta. Se continua a fallire, prova in una nuova scheda in modalità in incognito o l'app.",
      "bookingConfirmError": "Errore nella conferma della prenotazione",
      "unexpectedPaymentError": "Errore imprevisto nel processo di pagamento",
      "preBooking": {
        "noAvailability": {
          "title": "Questa opzione non è più disponibile",
          "description": "Scegli un'altra camera nell'hotel."
        },
        "hourUnavailable": {
          "title": "Quell'orario non è più disponibile",
          "description": "Prova con un altro orario di check-in."
        },
        "retryable": {
          "title": "Non è stato possibile continuare",
          "description": "Riprova tra qualche istante."
        },
        "network": {
          "title": "Problema di connessione",
          "description": "Controlla la connessione e riprova."
        },
        "missingData": {
          "title": "Dati mancanti",
          "description": "Controlla i tuoi dati di contatto e riprova."
        },
        "blacklist": {
          "title": "Non possiamo completare la prenotazione",
          "description": "Contattaci per continuare."
        },
        "duplicatedBook": {
          "title": "Non è stato possibile continuare",
          "description": "Controlla le tue prenotazioni o riprova tra qualche minuto."
        },
        "invalidPromo": {
          "title": "Codice promozionale non valido",
          "description": "Rimuovilo e riprova."
        },
        "paymentFailed": {
          "title": "Impossibile avviare il pagamento",
          "description": "Riprova tra qualche istante."
        },
        "actions": {
          "changeHour": "Scegli un altro orario",
          "viewHotel": "Vedi hotel",
          "retry": "Riprova",
          "reviewData": "Rivedi i miei dati",
          "removePromo": "Rimuovi codice e riprova",
          "myBookings": "Vedi le mie prenotazioni"
        }
      }
    }
  },
  "confirm": {
    "meta": {
      "title": "Pagamento riuscito",
      "description": "La tua prenotazione è stata confermata"
    },
    "header": {
      "title": "Pagamento riuscito!",
      "subtitle": "La tua prenotazione è stata confermata",
      "reference": "Riferimento:"
    },
    "loading": "Verifica del pagamento...",
    "personalData": {
      "title": "Dati personali",
      "name": "Nome",
      "lastName": "Cognome",
      "email": "Email",
      "phone": "Telefono"
    },
    "location": {
      "title": "Posizione"
    },
    "help": {
      "title": "Hai bisogno di aiuto?"
    },
    "buttons": {
      "viewBookings": "Vedi le mie prenotazioni",
      "searchMore": "Cerca altri hotel"
    }
  },
  "onDemandPage": {
    "title": "Non trovi disponibilità? Ce ne occupiamo noi",
    "subtitle": "Raccontaci cosa cerchi e il nostro team valuta le opzioni di soggiorno a ore per la tua destinazione e le tue date.",
    "sections": {
      "contact": "Dati di contatto",
      "trip": "Destinazione e date",
      "additional": "Informazioni aggiuntive"
    },
    "fields": {
      "name": "Nome",
      "email": "Email",
      "destination": "Destinazione",
      "destinationPlaceholder": "Cerca città",
      "checkinDate": "Data di arrivo",
      "checkinTime": "Ora di check-in",
      "pack": "Pack ore",
      "summary": "Riepilogo",
      "attemptedBooking": "Cosa hai provato a prenotare?",
      "attemptedPlaceholder": "Hotel, link o dettagli del soggiorno cercato"
    },
    "privacy": {
      "checkboxBefore": "Accetto ",
      "link": "l'informativa sulla privacy",
      "checkboxAfter": " e il trattamento dei miei dati per gestire questa richiesta."
    },
    "submit": "Invia richiesta",
    "backHome": "Torna alla home",
    "success": {
      "title": "Richiesta ricevuta",
      "body": "Abbiamo registrato la tua richiesta. Ti contatteremo il prima possibile.",
      "backSearch": "Torna alla ricerca hotel"
    },
    "errors": {
      "required": "Campo obbligatorio",
      "email": "Email non valida",
      "privacy": "Devi accettare l'informativa sulla privacy",
      "attemptedMax": "Testo troppo lungo",
      "generic": "Impossibile inviare la richiesta. Riprova.",
      "rateLimit": "Hai inviato troppe richieste. Attendi qualche minuto e riprova.",
      "timeOnTheHour": "Scegli un'ora in punto",
      "validationToastTitle": "Impossibile inviare",
      "checkinPast": "Data e ora di check-in devono essere successive al momento attuale.",
      "roomsRange": "Scegli tra 1 e 10 camere"
    }
  },
  "strapi": {
    "hotelPage": {
      "descripcion": "Descrizione",
      "ubicacion": "Posizione",
      "servicios": "Servizi",
      "reserva": "Prenota una camera",
      "verHabitaciones": "Vedi camere",
      "preguntas": "Domande frequenti",
      "info": "Informazioni importanti",
      "distance_airport": "Distanza dall'aeroporto",
      "shuttle_service": "Servizio navetta",
      "shuttle_service_information": "Informazioni sul servizio navetta",
      "taxi_distance": "Distanza in taxi",
      "public_transport": "Trasporto pubblico",
      "noRooms": "Tutte le camere disponibili per questo hotel sono esaurite per la data selezionata",
      "noRoomsEmpty": {
        "titulo": "Nessuna camera per questa data",
        "descripcion": "Le camere sono complete per il giorno scelto. Scegli un'altra data disponibile."
      },
      "extraDescription": "Scegli gli extra per completare la tua esperienza BYHOURS",
      "extra": {
        "titulo": "Extra",
        "subtitulo": "Gli extra possono essere aggiunti dopo aver selezionato la camera"
      },
      "max_pers": {
        "titulo": "Massimo",
        "subtitulo": "persone"
      },
      "noDispo": {
        "titulo": "Nessuna disponibilità in questo hotel",
        "subtitulo": "Attualmente non disponibile",
        "descripcionAmigable": "Non c'è disponibilità in questo hotel al momento."
      },
      "hotelesCercanos": "Scopri altri hotel nelle vicinanze"
    },
    "searchPage": {
      "filtroHora": "Ora check-in",
      "resultados": "hotel a ore in",
      "filtroPack": "Pacchetto",
      "filtroPromo": "Promozione",
      "filtroPrecio": "Prezzo",
      "filtroEstrella": "Categoria",
      "filtroServicio": "Servizi",
      "resultadosAlternativos": "Visualizza altri hotel in",
      "resultadosNear": "Hotel vicino",
      "horasEntrada": "Orari di check-in disponibili",
      "sinHorasEntrada": "Non disponibile",
      "searchZona": "Cerca in questa area",
      "sinResultados": {
        "titulo": "Oh, no :( Non ci sono hotel disponibili per la tua ricerca, prova inserendo un giorno, un'ora o una destinazione diversi.",
        "subtitulo": null
      },
      "sinResultadoFiltro": {
        "titulo": "Non ci sono hotel con i filtri selezionati",
        "subtitulo": null
      },
      "sinHoteles": {
        "titulo": "Ops! Delle 600 città nelle quali puoi prenotare hotel a ore, ne hai trovata una in cui non siamo ancora disponibili.",
        "subtitulo": null
      },
      "onDemand": {
        "titulo": "Non riesci a trovare quello che stai cercando?",
        "subtitulo": "L'abbiamo trovato in 24 ore!"
      },
      "buscandoFechasCercanas": "Ricerca disponibilità in altre date…",
      "disponiblesFechasCercanas": "Disponibili in date vicine a",
      "disponibleEl": "Disponibile il",
      "probarOtraFecha": "Prova un'altra data:",
      "chipManana": "Domani",
      "chipPasadoManana": "Dopodomani",
      "ordenacion": [
        "Rilevanza",
        "Prezzo (dal più basso al più alto)",
        "Prezzo (dal più alto al più basso)",
        "Categoria (dal più basso al più alto)",
        "Categoria (dal più alto al più basso)"
      ]
    },
    "homePage": {
      "labelHoteles": "Vedi più hotel in"
    },
    "global": {
      "header": {
        "tituloIdioma": "Lingua",
        "tituloMoneda": "Valuta",
        "tituloDestinos": "Destinazioni",
        "labelDestinos": "Destinazioni",
        "labelPartners": "Partner",
        "labelAyuda": "Aiuto",
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcellona",
          "berlin": "Berlino",
          "paris": "Parigi",
          "roma": "Roma",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Città del Messico",
          "lima": "Lima",
          "panama": "Città di Panama"
        },
        "buttonDestinos": {
          "label": "Vedi tutte le destinazioni",
          "link": "destinos",
          "url": false
        },
        "buttonFunciona": {
          "label": "Come funziona?",
          "link": "como-funciona",
          "url": false
        },
        "buttonPartner": {
          "hoteleros": "Albergatori",
          "agencias": "Agenzie di viaggio"
        },
        "buttonAyuda": {
          "contacto": "Contatto",
          "preguntas": "Domande frequenti"
        }
      },
      "footer": {
        "tituloPrivacidad": "Privacy",
        "tituloInformacion": "Informazioni",
        "tituloHoteleros": "Albergatori",
        "subtituloHoteleros": "Unisciti a BYHOURS!",
        "tituloAgencia": "Sei un'agenzia?",
        "subtituloAgencia": "Unisciti a BYHOURS!",
        "tituloDestinos": "Alcune destinazioni",
        "tituloSiguenos": "Seguici",
        "tituloApp": "Scarica l'app",
        "keywords": {
          "hotelesPorHoras": "Hotel a ore",
          "hotelDeDia": "Hotel diurni",
          "habitacionPorHoras": "Camere a ore"
        },
        "privacidadLinks": {
          "acuerdo": "Accordo utente",
          "privacidad": "Informativa sulla privacy",
          "cookies": "Politica sui cookie"
        },
        "infoLinks": {
          "ayuda": "Aiuto",
          "contacto": "Contatto",
          "blog": "Blog",
          "unete": "Unisciti al team"
        },
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcellona",
          "berlin": "Berlino",
          "paris": "Parigi",
          "roma": "Roma",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Città del Messico",
          "lima": "Lima",
          "panama": "Città di Panama",
          "zurich": "Zurigo",
          "viena": "Vienna",
          "londres": "Londra",
          "milan": "Milano",
          "doha": "Doha",
          "buenosAires": "Buenos Aires",
          "quito": "Quito",
          "santiago": "Santiago del Cile"
        },
        "buttonAgencia": {
          "label": "Accesso al portale"
        },
        "buttonHotelero": {
          "label": "Accesso al portale"
        },
        "redes": {
          "instagram": "Instagram",
          "facebook": "Facebook",
          "x": "X",
          "linkedin": "Linkedin",
          "tiktok": "Tik Tok",
          "youtube": "Youtube"
        },
        "buttonsApp": {
          "appStore": "App Store",
          "googlePlay": "Google Play"
        }
      }
    }
  },
  "hoteliersPage": {
    "breadcrumb": {
      "home": "Home",
      "current": "Per gli hotel"
    },
    "hero": {
      "title": "Trasforma le ore vuote delle camere in ricavi",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con las reglas que tú gestiones; franja horaria, disponibilidad y canal propio, sin compromiso de cupo.",
      "cta": "Unisciti alla nostra rete di hotel",
      "imageAlt": "BYHOURS per hotel"
    },
    "whyTitle": "Perché BYHOURS",
    "features": [
      {
        "title": "Massima flessibilità",
        "description": "Gestisci la piattaforma come preferisci: come e quando offrire i microsoggiorni."
      },
      {
        "title": "Nessun minimo garantito",
        "description": "Non richiediamo un numero minimo di camere. Apri e chiudi la disponibilità quando vuoi."
      },
      {
        "title": "Prodotto differenziato",
        "description": "Distinto dalla vendita per notte: meno problemi di parità tariffaria sui canali abituali."
      },
      {
        "title": "Ricavi sulle camere",
        "description": "Monetizza fasce e giornate in cui la camera non si vende a notte."
      },
      {
        "title": "Nuovi segmenti di ospiti",
        "description": "Raggiungi viaggiatori d’affari, scali e tempo libero che prenotano a ore."
      },
      {
        "title": "Nessun vincolo",
        "description": "Prova il modello senza impegni di lungo periodo."
      }
    ],
    "whoWeAre": {
      "title": "Chi siamo",
      "description": "Leader nei microsoggiorni dal 2012. Cifre cumulative e rete attuale: catene internazionali e indipendenti aumentano il RevPAR con BYHOURS in centinaia di destinazioni.",
      "ctaQuestion": "Vuoi vedere come si adatta al tuo hotel?",
      "ctaButton": "Richiedi informazioni"
    },
    "stats": [
      {
        "title": "+15 M€",
        "description": "Generati per i nostri hotel (cumulato)"
      },
      {
        "title": "+300 K",
        "description": "Prenotazioni di microsoggiorni generate"
      },
      {
        "title": "+250 K",
        "description": "Clienti soddisfatti"
      },
      {
        "title": "24",
        "description": "Mercati in Europa, America Latina e Medio Oriente"
      },
      {
        "title": "+600",
        "description": "Destinazioni disponibili"
      },
      {
        "title": "+4000",
        "description": "Hotel partner che già generano entrate extra"
      }
    ],
    "video": {
      "title": "BYHOURS per il tuo hotel",
      "description": "Scopri come BYHOURS può aiutarti a monetizzare le camere vuote e aumentare i ricavi.",
      "iframeTitle": "Video BYHOURS per hotel"
    },
    "widget": {
      "title": "Vendi a ore dal tuo sito",
      "description": "Con una riga di codice il sito mostra un pulsante flottante che apre la ricerca oraria: gli ospiti prenotano microsoggiorni subito, senza uscire dall’ambiente del tuo hotel.",
      "pillars": [
        {
          "title": "Integrazione in pochi minuti",
          "description": "Go-live leggero: niente progetti lunghi o modifiche al sito oltre allo snippet concordato con il tuo team o fornitore."
        },
        {
          "title": "Prenotazione oraria in un clic",
          "description": "I visitatori vedono un pulsante flottante che apre il finder dei microsoggiorni: scelgono la fascia e completano la prenotazione sul tuo sito."
        },
        {
          "title": "Tu resti al comando",
          "description": "Prezzo, disponibilità e regole arrivano ancora dal tuo extranet BYHOURS: il widget mostra solo ciò che autorizzi."
        }
      ],
      "featuresSubtitle": "Funzionalità del widget",
      "widgetFeatures": [
        {
          "title": "Colori e testi del brand",
          "description": "Imposta colori primario e secondario, raggio del pulsante e testo del CTA; i contenuti del finder possono seguire le impostazioni lingua."
        },
        {
          "title": "Flottante o incorporato",
          "description": "Pulsante in un angolo o blocco nella pagina: scegli cosa si adatta a layout e navigazione."
        },
        {
          "title": "Regole diverse su mobile e desktop",
          "description": "Imposta posizione, offset e comportamento separatamente per schermi grandi e piccoli così non copri contenuti importanti."
        }
      ],
      "cta": "Richiedi integrazione",
      "figcaption": "Il pulsante flottante apre il finder dei microsoggiorni senza uscire dal sito dell’hotel.",
      "imageAlt": "Esempio del widget di prenotazione oraria integrato nel sito di un hotel"
    },
    "examples": {
      "title": "Tre esempi reali di clienti",
      "description": "Strutture che già fatturano microsoggiorni con BYHOURS. Le cifre sono stime indicative in base al mercato e alla politica commerciale.",
      "benefitLabel": "Beneficio per l’hotel",
      "bookingsLabel": "Prenotazioni con BYHOURS",
      "cta": "Voglio entrare nella rete",
      "cases": [
        {
          "badge": "Barcellona",
          "title": "Hotel 4 stelle",
          "description": "Mercato misto congressi, crociere e turismo urbano: i microsoggiorni colmano le fasce tra notti e ultimo minuto in zona molto competitiva.",
          "revenue": "+700k €",
          "bookings": "+14k"
        },
        {
          "badge": "Madrid",
          "title": "Hotel urbano",
          "description": "Hotel senza categoria stelle che integra il canale orario per passanti, smart working e soggiorni brevi senza competere solo sul BAR notte.",
          "revenue": "+300k €",
          "bookings": "+7k"
        },
        {
          "badge": "Bogotá",
          "title": "Hotel 5 stelle",
          "description": "Profilo premium in capitale andina: business, eventi e corporate che valorizzano pacchetti ore allineati ad agende strette.",
          "revenue": "+400k €",
          "bookings": "+12k"
        }
      ]
    },
    "testimonialsTitle": "Cosa dicono i nostri partner",
    "testimonials": [
      {
        "quote": "La flessibilità su prezzo e disponibilità last minute ci aiuta a migliorare l’ADR sulle fasce che prima restavano vuote.",
        "name": "Juan Reyna",
        "role": "Director of Sales & Marketing — Hilton Barcelona",
        "kind": "hilton"
      },
      {
        "quote": "In un mercato in cui gli ospiti sono sempre più eclettici, una soluzione come BYHOURS ci permette di attrarre un tipo di cliente che non sempre trova un’offerta adatta alle proprie esigenze. Inoltre, una piattaforma di facile utilizzo che offre tutto il controllo e la flessibilità necessari rende la generazione di entrate aggiuntive più semplice che mai.",
        "name": "Xavier Micó",
        "role": "General Manager — Four Points by Sheraton",
        "kind": "marriott"
      },
      {
        "quote": "La piattaforma BYHOURS offre una soluzione innovativa e flessibile perché gli hotel massimizzino l’occupazione delle camere. In particolare si possono vendere camere non solo per giornate intere (24 h), ma anche per fasce di 3 o 6 ore. Questo apre nuove opportunità per ridurre i vuoti e generare entrate aggiuntive.\n\nL’extranet è solida nel complesso: chiara, intuitiva e permette di gestire gli annunci in modo semplice ed efficiente. Anche senza un lungo periodo di formazione ci si orienta subito e si usano le funzioni principali senza problemi.\n\nUn altro punto di forza è l’assistenza: le richieste vengono gestite in fretta e sempre con cortesia e professionalità. Ci si sente seguiti e supportati, il che rende molto piacevole collaborare. Nel complesso BYHOURS è una piattaforma moderna e ben progettata che convince per funzionalità e servizio eccellente.",
        "name": "Robert Franke",
        "role": "Channelmanagement Coordinator — GHC Hotels",
        "kind": "ghc"
      },
      {
        "quote": "BYHOURS è diventato uno strumento essenziale per la nostra operatività quotidiana. Offre la massima flessibilità nella gestione di disponibilità, tariffe, pacchetti personalizzati e controllo completo della strategia commerciale, consentendo un adattamento immediato alle fluttuazioni di mercato, cancellazioni, partenze anticipate, ecc.\n\nL’impatto sui ricavi è stato molto positivo: abbiamo ottenuto un aumento significativo degli introiti. L’interfaccia intuitiva, la totale flessibilità e l’eccezionale assistenza clienti semplificano notevolmente i processi, riducendo i tempi di gestione e minimizzando gli errori operativi.\n\nÈ attualmente un complemento indispensabile per il nostro hotel.",
        "name": "Anonimo",
        "role": "Partner hotel",
        "kind": "anonymous"
      }
    ],
    "demand": {
      "title": "Il tuo hotel raggiunge questi profili di domanda",
      "description": "Ecco come prenotano a ore chi cerca il tuo hotel: coprire questi segmenti aumenta occupazione e ricavi oltre il solo schema notte intera.",
      "items": [
        {
          "title": "Business e lavoro",
          "paragraph": "Professionisti che servono Wi‑Fi, una pausa tra riunioni o privacy fuori ufficio. Prenotano fasce diurne che si adattano al tuo inventario tra un soggiorno e l’altro."
        },
        {
          "title": "Viaggiatori",
          "paragraph": "Passeggeri con coincidenze, ritardi o lunghe attese: doccia, riposo e comfort vicino a aeroporto o stazione. Il tuo hotel risponde a un bisogno che la notte da sola non sempre copre."
        },
        {
          "title": "Stile di vita e tempo libero",
          "paragraph": "Spa, piscina o terrazza prima o dopo concerti, shopping o weekend urbani. Catturi il tempo libero che preferisce pagare solo le ore usate."
        }
      ]
    },
    "steps": {
      "title": "Come entrare in BYHOURS?",
      "description": "Guadagnare con BYHOURS è semplice. In tre passi inizi a monetizzare le camere vuote.",
      "items": [
        {
          "title": "Registrazione",
          "description": "Compila il modulo e ti ricontatteremo.",
          "linkToForm": true
        },
        {
          "title": "Formazione",
          "description": "In un breve onboarding carichi la prima disponibilità e impari a usare la piattaforma.",
          "linkToForm": false
        },
        {
          "title": "Vendita",
          "description": "Il tuo hotel è online: puoi vendere e monetizzare le camere vuote con BYHOURS.",
          "linkToForm": false
        }
      ]
    },
    "form": {
      "title": "Unisciti alla nostra rete di hotel",
      "description": "Invia la richiesta e ti ricontatteremo il prima possibile per parlare del tuo hotel e dei prossimi passi. I dati servono solo a rispondere alla richiesta; titolare del trattamento: BYHOURS Travel S.L.",
      "successTitle": "Richiesta inviata",
      "successDescription": "Grazie. Abbiamo ricevuto il tuo messaggio e ti contatteremo al più presto.",
      "hotelSection": "Dati dell'hotel",
      "contactSection": "Contatto",
      "hotelName": "Nome dell'hotel",
      "website": "Sito web (opzionale)",
      "rooms": "Numero di camere",
      "roomsPlaceholder": "Seleziona un intervallo…",
      "cityCountry": "Località dell'hotel",
      "cityPlaceholder": "Cerca città…",
      "contactName": "Nome del referente",
      "email": "Email",
      "phone": "Telefono",
      "comments": "Commenti (opzionale)",
      "commentsPlaceholder": "Scrivi di cosa hai bisogno: collaborazione con noi, integrazione del widget, dubbi commerciali…",
      "privacyBefore": "Accetto la ",
      "privacyLink": "informativa sulla privacy",
      "privacyAfter": " e il trattamento dei miei dati per rispondere a questa richiesta.",
      "submit": "Invia richiesta",
      "websitePlaceholder": "https://hotel.example.com"
    },
    "faq": {
      "title": "Hai dubbi?",
      "description": "Risposte a ciò che chiedono spesso revenue manager e team commerciali.",
      "items": [
        {
          "label": "Cos’è un microsoggiorno?",
          "content": "Una prenotazione hotel di 3, 6 o 24 ore in cui l’ospite sceglie l’orario di ingresso nella giornata. Tu controlli prezzo e disponibilità per fascia."
        },
        {
          "label": "C’è un minimo camere o un vincolo?",
          "content": "Non richiediamo un minimo di camere né un periodo di permanenza. Puoi provare il modello e adattarlo quando serve."
        },
        {
          "label": "Influisce sul BAR o sullo yield?",
          "content": "Il prodotto è una linea distinta per altri segmenti (business, scali, ultimo minuto), utile a riempire i vuoti senza sostituire la vendita notte."
        },
        {
          "label": "Come si fissa il prezzo per fascia?",
          "content": "Definisci tariffe e regole dei microsoggiorni nell’extranet con la flessibilità della tua strategia. Il team ti supporta nella configurazione iniziale."
        },
        {
          "label": "Ci sono commissioni o split ricavi?",
          "content": "Le condizioni commerciali (commissioni, liquidazioni) si concordano in ingresso al programma partner. Le spieghiamo al primo contatto dopo la richiesta."
        },
        {
          "label": "Si integra con PMS o channel manager?",
          "content": "Valutiamo le integrazioni in base al tuo stack. Indica quali sistemi usi nel modulo o nella call di benvenuto e troviamo l’opzione migliore."
        },
        {
          "label": "Come funziona la fatturazione verso ospite e hotel?",
          "content": "BYHOURS incassa dall’ospite secondo il flusso del contratto partner; fatturazione e liquidazioni le spieghiamo in onboarding."
        },
        {
          "label": "Cosa serve per iniziare?",
          "content": "Compila il modulo in questa pagina. Il team ti guida nella configurazione e nella prima pubblicazione di disponibilità sull’extranet."
        }
      ]
    },
    "toast": {
      "validationTitle": "Controlla il modulo"
    },
    "errors": {
      "server": "Invio non riuscito. Riprova.",
      "rateLimit": "Hai inviato troppe richieste. Attendi qualche minuto e riprova."
    },
    "validation": {
      "hotelName": "Indica il nome dell'hotel",
      "websiteMax": "URL del sito troppo lungo",
      "rooms": "Seleziona un intervallo di camere",
      "cityCountry": "Indica città e paese",
      "contactName": "Indica il nome del referente",
      "emailRequired": "Indica la email",
      "emailInvalid": "Email non valida",
      "phone": "Indica un telefono",
      "commentsMax": "Massimo 4000 caratteri",
      "privacy": "Devi accettare l'informativa sulla privacy"
    },
    "roomRanges": [
      {
        "label": "1 – 9",
        "value": "1-9"
      },
      {
        "label": "10 – 19",
        "value": "10-19"
      },
      {
        "label": "20 – 59",
        "value": "20-59"
      },
      {
        "label": "60 – 99",
        "value": "60-99"
      },
      {
        "label": "100 o più",
        "value": "100+"
      }
    ]
  }
}
